<!-- 个人设置，API秘钥弹窗 -->
<template>
  <div class="search">
    <!-- 查询表单 -->
    <el-form :inline="true" :model="formInline" class="demo-form-inline ">
      <el-form-item label="APP key">
        <el-input v-model="formInline.ak" clearable placeholder="APP key"></el-input>
      </el-form-item>
      <el-form-item :label="$t('state')">
        <el-select v-model="formInline.enable" clearable :placeholder="$t('state')" :popper-append-to-body="true">
          <el-option :label="$t('enable')" value="1"></el-option>
          <el-option :label="$t('disable')" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showSecret" class="serachBtn">{{ $t('query') }}</el-button>
        <el-button type="primary" @click="addSecret" class="add-btn">{{ $t('newlyAded') }}</el-button>
      </el-form-item>
    </el-form>
    <!-- table 列表 -->
    <el-table :data="secretData" height="300px" style="width: 100%;" @sort-change="sortChange">
      <el-table-column prop="appKey" label="APP key" sortable="appKey" :sort-orders="['ascending', 'descending']"> </el-table-column>
      <el-table-column prop="secretKey" label="Secret key" sortable="secretKey" :sort-orders="['ascending', 'descending']"> </el-table-column>
      <el-table-column prop="createdTime" :label="$t('creationTime')" sortable="createdTime" :sort-orders="['ascending', 'descending']"> </el-table-column>
      <el-table-column prop="enable" :label="$t('state')" width="100" sortable="enable" :sort-orders="['ascending', 'descending']">
        <template slot-scope="scope">
          {{ scope.row.enable === 1 ? $t('enable') : '' }}
          {{ scope.row.enable === 0 ? $t('disable') : '' }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('operationh')" min-width="50">
        <template slot-scope="scope">
          <span class="editClick" @click="enableSecret(scope.row.id, 1)" v-if="scope.row.enable == 0">{{
            $t('enable')
          }}</span>
          <span class="editClick" @click="enableSecret(scope.row.id, 0)" v-if="scope.row.enable == 1">{{
            $t('disable')
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>
<script>
import { findUserSecret, addSecret, enableSecret, disableSecret } from '@/api/secret/secret'
export default {
  data() {
    return {
      // API秘钥 参数
      formInline: {
        ak: '',
        enable: null,
      },
      // API秘钥 table数据
      secretData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
    }
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.currentPage = 1
      this.findUserSecret()
    },
    // 打开api秘钥弹窗
    showSecret() {
      this.currentPage = 1
      this.findUserSecret()
    },
    // 查询api秘钥列表
    findUserSecret() {
      let params = {
        ak: this.formInline.ak,
        enable: this.formInline.enable,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      findUserSecret(params).then(res => {
        if (res.state === 0) {
          this.secretData = res.data.list
          this.totalData = res.data.total
        }
      })
    },
    // 新增api秘钥
    addSecret() {
      addSecret().then(res => {
        if (res.state === 0) {
          this.$message({
            type: 'success',
            message: this.$t('addingApiSecret'),
            duration: 1000,
          })
          this.findUserSecret()
        }
      })
    },
    // 禁用启用api秘钥
    enableSecret(id, enable) {
      if (enable === 1) {
        enableSecret(id).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('enabledApiSecret'),
              duration: 1000,
            })
            for (let item of this.secretData) {
              if (item.id === id) {
                item.enable = 1
              }
            }
          }
        })
      } else if (enable === 0) {
        disableSecret(id).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('disabledApiSecret'),
              duration: 1000,
            })
            for (let item of this.secretData) {
              if (item.id === id) {
                item.enable = 0
              }
            }
          }
        })
      }
    },
    // 每页查询 val 条数据
    handleSizeChange(val) {
      this.pageSize = val
      this.findUserSecret()
    },
    // 点击页数跳转到 val 页
    handleCurrentChange(val) {
      this.currentPage = val
      this.findUserSecret()
    },
  },
  mounted() {
    this.findUserSecret()
  },
  computed: {},
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
>>>.el-table
  height: 400px!important
</style>
